let store = {
  namespaced: true,
  state: {
    message: null,
    show: false
  },
  mutations: {
    FILE_UPLOADING (state) {
      state.message = '檔案上傳中。'
      state.show = true
    },
    NOT_FOUND (state, message) {
      state.message = message || '找不到需求的資料。'
      state.show = true
    },
    DELETE_FAILED (state, message) {
      state.message = message || '刪除失敗。可能是因為項目目前在某處還被使用。'
      state.show = true
    },
    CREATE_FAILED (state, message) {
      state.message = message || '創建失敗。可能是因為缺少某個欄位。'
      state.show = true
    },
    NOT_AUTHORIZED (state, message) {
      state.message = message || '未經授權存取。'
      state.show = true
    },
    UPDATE_FAILED (state, message) {
      state.message = message || '更新失敗。可能是因為缺少某個欄位。'
      state.show = true
    },
    SERVER_ERROR (state, message) {
      state.message = message || '伺服器錯誤，取得資料失敗。'
      state.show = true
    },
    HIDE (state, payload) {
      state.message = null
      state.show = false
    }
  },
  actions: {
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/snackbar.js